import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../axios";
import validateError from "../../../utils/validateError";

const initialState = {
  loading: true,
  list: [],
  error: null,
  currentId: null,
  subLoading: false,
  notice: null,
  versionLoading: false,
};

export const fetchPluginList = createAsyncThunk("pluginList/fetchPluginList", async () => {
  const response = await axios.get("/api/v1/plugin-list/");
  return response.data.data;
});

export const addPluginListItem = createAsyncThunk("pluginList/addPluginListItem", async (data) => {
  const response = await axios.post("/api/v1/plugin-list/add-item", data);
  return response.data.data;
});

export const updatePluginListItem = createAsyncThunk("pluginList/updatePluginListItem", async ({ id, data }) => {
  const response = await axios.post(`/api/v1/plugin-list/${id}`, data);
  return response.data.data;
});

export const deletePluginListItem = createAsyncThunk("pluginList/deletePluginListItem", async (id) => {
  const response = await axios.delete(`/api/v1/plugin-list/${id}`);
  return id;
});

export const addNewVersion = createAsyncThunk("pluginList/addNewVersion", async (info) => {
  try {
  } catch (error) {
    throw new Error(validateError(error));
  }
});

const pluginListSlice = createSlice({
  name: "pluginList",
  initialState,
  reducers: {
    setPluginList: (state, action) => {
      state.items = action.payload;
    },
    setCurrentId: (state, action) => {
      state.currentId = action.payload;
    },
    setPluginListError: (state, action) => {
      state.error = action.payload;
    },
    logout: (state) => {
      state = initialState;
    },
    setPluginListSubLoading: (state, action) => {
      state.subLoading = action.payload;
    },
    setPluginListVersionLoading: (state, action) => {
      state.versionLoading = action.payload;
    },
    setPluginListNotice: (state, action) => {
      state.notice = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPluginList.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchPluginList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.list = action.payload;
    });
    builder.addCase(fetchPluginList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.list = [];
    });

    // add Plugin
    builder.addCase(addPluginListItem.pending, (state, action) => {
      state.error = "";
      state.subLoading = true;
    });
    builder.addCase(addPluginListItem.fulfilled, (state, action) => {
      state.error = "";
      state.subLoading = false;
      state.list.push(action.payload);
    });
    builder.addCase(addPluginListItem.rejected, (state, action) => {
      state.error = action.error.message;
      state.subLoading = false;
    });

    // delete
    builder.addCase(deletePluginListItem.fulfilled, (state, action) => {
      state.list = state.list.filter((item) => item._id !== action.payload);
    });

    // update
    builder.addCase(updatePluginListItem.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(updatePluginListItem.fulfilled, (state, action) => {
      state.subLoading = false;
      state.list = state.list.map((item) => (item._id === action.payload._id ? action.payload : item));
    });
    builder.addCase(updatePluginListItem.rejected, (state, action) => {
      state.subLoading = false;
    });
  },
});

export default pluginListSlice.reducer;

export const { setPluginList, setCurrentId, logout, setPluginListError, setPluginListSubLoading, setPluginListNotice, setPluginListVersionLoading } = pluginListSlice.actions;
